document.addEventListener('DOMContentLoaded', () => {
	const docEl = document.documentElement;
	const body = document.body;
	let ticking = false;
	let lastScrollTop = 0;

	const updateScrollClasses = () => {
		const scrollTop = docEl.scrollTop || window.pageYOffset;

		// Toggle classes only if necessary
		const isScrolled = scrollTop > 30;
		const isScrolledUp = scrollTop < lastScrollTop;

		if (body.classList.contains('is-scrolled') !== isScrolled) {
			body.classList.toggle('is-scrolled', isScrolled);
		}

		if (body.classList.contains('is-scrolled-up') !== isScrolledUp) {
			body.classList.toggle('is-scrolled-up', isScrolledUp);
		}

		lastScrollTop = Math.max(0, scrollTop);
		ticking = false;
	};

	const onScroll = () => {
		if (!ticking) {
			requestAnimationFrame(updateScrollClasses);
			ticking = true;
		}
	};

	// Run on load and attach event listener
	updateScrollClasses();
	window.addEventListener('scroll', onScroll, { passive: true });
});
